var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "student-management" } },
    [
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: {
            centered: "",
            "hide-footer": "",
            title:
              (_vm.model.id === "" ? "Tambah" : "Perbarui") +
              " Kategori Pelanggan"
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("fg-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.modelValidations.name,
                        expression: "modelValidations.name"
                      }
                    ],
                    attrs: {
                      required: true,
                      "for-input": "name",
                      type: "text",
                      name: "name",
                      id: "name",
                      label: "Name",
                      placeholder: "Masukkan nama kategori",
                      error: _vm.errors.first("name"),
                      "data-vv-as": "name"
                    },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "description",
                      type: "text",
                      name: "description",
                      id: "description",
                      label: "description",
                      placeholder: "Masukkan deskripsi kategori"
                    },
                    model: {
                      value: _vm.model.description,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description"
                    }
                  }),
                  _vm._v(" "),
                  _c("save-data-button", {
                    attrs: {
                      disabled: _vm.saveButtonData.isLoading,
                      "is-create": _vm.model.id === "",
                      state:
                        _vm.saveButtonData.isLoading &&
                        _vm.saveButtonData.state === 1
                          ? 2
                          : _vm.saveButtonData.state,
                      "is-loading": _vm.saveButtonData.isLoading
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-3",
                      attrs: { variant: "warning" },
                      on: { click: _vm.hideModal }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        id: "show-btn",
                        variant: "primary",
                        title: "Add Hospital Service"
                      },
                      on: { click: _vm.showModal }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("paginated-table", {
            ref: "dataTable",
            attrs: {
              "can-delete": false,
              "can-show": false,
              "modal-view": true,
              "param-no-id": true,
              "data-url": _vm.apiUrl,
              "data-key": _vm.dataKey,
              "data-columns": _vm.columns,
              "data-params": ["is_active", "name"]
            },
            on: { editData: _vm.doEdit },
            scopedSlots: _vm._u([
              {
                key: "content_created_by",
                fn: function(defaultSlotScope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(defaultSlotScope.rowData.created_by.name) +
                        " (" +
                        _vm._s(
                          defaultSlotScope.rowData.created_by.roles[0].name
                        ) +
                        ")\n      "
                    )
                  ]
                }
              },
              {
                key: "content_description",
                fn: function(defaultSlotScope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          defaultSlotScope.rowData.description !== null
                            ? defaultSlotScope.rowData.description
                            : "-"
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "content_last_updated_by",
                fn: function(defaultSlotScope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(defaultSlotScope.rowData.last_updated_by.name) +
                        " (" +
                        _vm._s(
                          defaultSlotScope.rowData.last_updated_by.roles[0].name
                        ) +
                        ")\n      "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ff3a3da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff3a3da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Sizes/Index.vue
// module id = w4Ga
// module chunks = 4